import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo, useState } from 'react';
import { CYLINDO_OPTIONS } from 'commons/constants';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import buildCylindoUrl from '../usePDPCylindoViewer/cylindoCache/buildCylindoUrl';
const EMPTY_ARRAY = Object.freeze([]);
const useCylindoDimensionShots = t0 => {
  const $ = _c(30);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    upholsteryKey,
    cylindoVersion
  } = t1;
  const [selectedDimensionShotIndex, setSelectedDimensionShotIndex] = useState(0);
  const {
    data: basicDetails
  } = usePDPBasicDetails();
  const productId = basicDetails?.id;
  const cylindoDimensionCode = basicDetails?.custom_properties?.cylindo_dimension_code;
  const isCylindoProduct = !!basicDetails?.custom_properties?.cylindo_product;
  const dimensionalImageDesktop = basicDetails?.custom_properties?.dimensional_image_desktop;
  const dimensionalImageMobile = basicDetails?.custom_properties?.dimensional_image_mobile;
  let t2;
  bb0: {
    if (!cylindoDimensionCode || typeof cylindoDimensionCode !== "string") {
      t2 = EMPTY_ARRAY;
      break bb0;
    }
    let t3;
    if ($[2] !== cylindoDimensionCode) {
      t3 = cylindoDimensionCode.split(",").map(_temp).filter(Boolean);
      $[2] = cylindoDimensionCode;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    t2 = t3;
  }
  const dimensionCodes = t2;
  const hasCylindoDimensionShots = isCylindoProduct && dimensionCodes.length > 0;
  let t3;
  bb1: {
    if (!hasCylindoDimensionShots || !productId || dimensionCodes.length === 0) {
      t3 = EMPTY_ARRAY;
      break bb1;
    }
    let t4;
    if ($[4] !== cylindoVersion || $[5] !== dimensionCodes || $[6] !== productId || $[7] !== upholsteryKey) {
      let t5;
      if ($[9] !== cylindoVersion || $[10] !== productId || $[11] !== upholsteryKey) {
        t5 = (dimensionCode, index) => {
          const baseUrl = buildCylindoUrl({
            productId,
            kind: "dimensions",
            size: 1024,
            dimensionCode
          });
          const url = buildCylindoUrl({
            productId,
            kind: "dimensions",
            size: 1024,
            dimensionCode,
            features: upholsteryKey ? {
              [CYLINDO_OPTIONS.UPHOLSTERY]: upholsteryKey
            } : undefined,
            version: cylindoVersion || undefined
          });
          return {
            id: `dimension-${dimensionCode}`,
            src: url,
            baseUrl,
            dimensionCode,
            index
          };
        };
        $[9] = cylindoVersion;
        $[10] = productId;
        $[11] = upholsteryKey;
        $[12] = t5;
      } else {
        t5 = $[12];
      }
      t4 = dimensionCodes.map(t5);
      $[4] = cylindoVersion;
      $[5] = dimensionCodes;
      $[6] = productId;
      $[7] = upholsteryKey;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = t4;
  }
  const dimensionShotUrls = t3;
  const shouldShowCylindoDimensionShots = hasCylindoDimensionShots;
  const shouldShowStaticDimensionImages = !hasCylindoDimensionShots && (dimensionalImageDesktop || dimensionalImageMobile);
  const shouldShowDimensionThumbnail = shouldShowCylindoDimensionShots || shouldShowStaticDimensionImages;
  const currentDimensionShot = dimensionShotUrls[selectedDimensionShotIndex] || null;
  let t4;
  if ($[13] !== dimensionShotUrls.length) {
    t4 = () => {
      if (dimensionShotUrls.length > 1) {
        setSelectedDimensionShotIndex(prev => prev >= dimensionShotUrls.length - 1 ? 0 : prev + 1);
      }
    };
    $[13] = dimensionShotUrls.length;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const goToNextDimensionShot = t4;
  let t5;
  if ($[15] !== dimensionShotUrls.length) {
    t5 = () => {
      if (dimensionShotUrls.length > 1) {
        setSelectedDimensionShotIndex(prev_0 => prev_0 <= 0 ? dimensionShotUrls.length - 1 : prev_0 - 1);
      }
    };
    $[15] = dimensionShotUrls.length;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const goToPreviousDimensionShot = t5;
  const t6 = dimensionShotUrls.length > 1;
  let t7;
  if ($[17] !== currentDimensionShot || $[18] !== dimensionShotUrls || $[19] !== dimensionalImageDesktop || $[20] !== dimensionalImageMobile || $[21] !== goToNextDimensionShot || $[22] !== goToPreviousDimensionShot || $[23] !== hasCylindoDimensionShots || $[24] !== selectedDimensionShotIndex || $[25] !== shouldShowCylindoDimensionShots || $[26] !== shouldShowDimensionThumbnail || $[27] !== shouldShowStaticDimensionImages || $[28] !== t6) {
    t7 = {
      dimensionShotUrls,
      currentDimensionShot,
      selectedDimensionShotIndex,
      hasCylindoDimensionShots,
      hasMultipleDimensionShots: t6,
      dimensionalImageDesktop,
      dimensionalImageMobile,
      shouldShowCylindoDimensionShots,
      shouldShowStaticDimensionImages,
      shouldShowDimensionThumbnail,
      setSelectedDimensionShotIndex,
      goToNextDimensionShot,
      goToPreviousDimensionShot
    };
    $[17] = currentDimensionShot;
    $[18] = dimensionShotUrls;
    $[19] = dimensionalImageDesktop;
    $[20] = dimensionalImageMobile;
    $[21] = goToNextDimensionShot;
    $[22] = goToPreviousDimensionShot;
    $[23] = hasCylindoDimensionShots;
    $[24] = selectedDimensionShotIndex;
    $[25] = shouldShowCylindoDimensionShots;
    $[26] = shouldShowDimensionThumbnail;
    $[27] = shouldShowStaticDimensionImages;
    $[28] = t6;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  return t7;
};
export default useCylindoDimensionShots;
function _temp(code) {
  return code.trim();
}